import { render } from "./ListView.vue?vue&type=template&id=487922cb&scoped=true"
import script from "./ListView.vue?vue&type=script&lang=js"
export * from "./ListView.vue?vue&type=script&lang=js"

import "./ListView.vue?vue&type=style&index=0&id=487922cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487922cb"]])

export default __exports__